(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["reserve-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reserve-acknowledgement')) {
    customElements.define(
      'reserve-acknowledgement',
      class ReserveAcknowledgement extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('[data-reserve-checkbox]');
          if (!this.checkbox) return;

          this.hint = this.querySelector('[data-reserve-hint]');
          this.scope =
            this.closest('.product-details') ||
            this.closest('.shopify-section') ||
            document;

          this.checkbox.addEventListener('change', () => this.sync());

          // The theme re-renders the buy buttons on variant change, which wipes
          // the disabled state and the hidden input. Re-apply when that happens.
          this.observer = new MutationObserver(() => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.sync(), 60);
          });
          this.observer.observe(this.scope, { childList: true, subtree: true });

          this.sync();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          clearTimeout(this.timer);
        }

        get form() {
          return this.scope.querySelector('form[action*="/cart/add"]');
        }

        sync() {
          const ok = this.checkbox.checked;
          const form = this.form;

          if (form) {
            if (this.dataset.addProperty === 'true') this.applyProperty(form);

            form
              .querySelectorAll('button[name="add"], button[type="submit"]')
              .forEach((button) => {
                if (button.disabled !== !ok) button.disabled = !ok;
              });
          }

          if (this.dataset.gateAccelerated === 'true') {
            this.scope
              .querySelectorAll(
                'shopify-accelerated-checkout, .shopify-payment-button, .accelerated-checkout'
              )
              .forEach((node) => node.classList.toggle('reserve-locked', !ok));
          }

          if (this.hint) this.hint.hidden = ok;
        }

        applyProperty(form) {
          const name = this.dataset.propertyName;
          const value = this.dataset.propertyValue;
          if (!name || !value) return;

          let input = form.querySelector('input[data-reserve-property]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.setAttribute('data-reserve-property', '');
            form.appendChild(input);
          }
          const fieldName = 'properties[' + name + ']';
          if (input.name !== fieldName) input.name = fieldName;
          if (input.value !== value) input.value = value;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
